<template>
    <v-img
      :height="`${this.windowHeight}`"
      :src="require('@/assets/background/5.jpg')">
      <v-container fill-height fluid pa-0 style="background: #ffffffaa">
        <v-layout align-center justify-center>
          <v-flex xs10 sm10 md10 lg10>
            <p class="display-2 font-weight-black black--text">{{ $t('serviceTitle') }}</p>
            <v-carousel hide-delimiters>
              <v-carousel-item
                v-for="item in services"
                :key="item.id"
                :src="require('@/assets/background/'+item.image)">
                <v-card width="100%" height="100%" color="#000000aa">
                  <v-container fill-height>
                    <v-layout align-center justify-center>
                      <v-flex class="text-xs-center" xs9 sm9 md9 lg9>
                        <v-card-text>
                          <v-img max-height="180" contain
                            :src="require('@/assets/icons/'+item.icon)"></v-img>
                        </v-card-text>
                        <v-card-text class="headline font-weight-bold">
                          {{ item.title }}
                        </v-card-text>
                        <v-card-text class="subheading font-weight-bold">
                          {{ item.content }}
                        </v-card-text>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-carousel-item>
            </v-carousel>
          </v-flex>
        </v-layout>
      </v-container>
    </v-img>
</template>

<script>
export default {
  data () {
    return {
      windowHeight: 1000,
      slideHeight: 500,
      services: [
        { id: 1, image: '1.jpg', icon: 'service-sample-white.png', title: this.$i18n.t('serviceTitle1'), content: this.$i18n.t('serviceDescription1') },
        { id: 2, image: '2.jpg', icon: 'service-sample-white.png', title: this.$i18n.t('serviceTitle2'), content: this.$i18n.t('serviceDescription2') },
        { id: 3, image: '3.jpg', icon: 'service-sample-white.png', title: this.$i18n.t('serviceTitle3'), content: this.$i18n.t('serviceDescription3') },
        { id: 4, image: '5.jpg', icon: 'service-sample-white.png', title: this.$i18n.t('serviceTitle4'), content: this.$i18n.t('serviceDescription4') }
      ]
    }
  },

  methods: {
    setSize () {
      this.windowHeight = window.innerHeight
      this.slideHeight = window.innerHeight * 0.8
    }
  },

  mounted () {
    this.setSize()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Services.vue